<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn v-if="hasFilters"
             small
             text
             class="normal-btn-text rounded-tag-small mt-1"
             @click="clearFilters">
        Limpar filtros
        <v-icon right small color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-lista-notas-fisicais-filter ref="filtros" @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 400px"
                      label="Busque por chave ou CNPJ"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListaNotasFisicaisFilter from '@/modules/notas-fiscais/ListaNotasFisicaisFilter.vue';

export default {
  props: {},
  computed: {
    ...mapGetters('listagemNotasFiscais', ['hasCustomFilters', 'statusOptions']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemNotasFiscais/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemNotasFiscais/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemNotasFiscais/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemNotasFiscais/searchText', searchText);
      },
    },
    hasFilters() {
      return this.hasCustomFilters || this.searchText;
    },
  },
  methods: {
    onClickRefresh() {
      this.$emit('refresh');
    },
    emitChange() {
      this.$emit('change');
    },
    clearFilters() {
      this.searchText = null;
      this.$refs.filtros.clearFilters();
    },
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxListaNotasFisicaisFilter: ListaNotasFisicaisFilter,
  },
};
</script>
